import { render, staticRenderFns } from "./Gzzjwh.vue?vue&type=template&id=5df12689"
import script from "./Gzzjwh.vue?vue&type=script&lang=js"
export * from "./Gzzjwh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports